import { useauthMeQuery } from '@/types/generated/graphql';
import { AppModal } from '@components/form/Modal';
import { cacheOnly } from '@shared/constants';
import { useUserGuideStore } from '@shared/store/user-guide.store';
import { capitalize } from '@shared/utils/capitalize';
import { Modal } from 'antd';
import { RiCloseLine } from 'react-icons/ri';
import { useTranslation } from 'react-i18next';
import { useDisableTourGuide } from './hooks/use-disable-tour-guide';

export function UserGuideTabView() {
  const {
    isUserGuideOpen,
    isTourOpen,
    isCloseConfirmOpen,
    openCloseConfirm,
    closeCloseConfirm,
    closeTour,
    confirmClose,
    startTour,
    tourCurrentIndex,
  } = useUserGuideStore();
  const { t } = useTranslation();
  const { disableTourGuide } = useDisableTourGuide();
  const { data } = useauthMeQuery(cacheOnly);
  const tourGuideEnabled = Boolean(data?.authMe?.data?.user?.tourGuideEnabled);

  if (!isUserGuideOpen && !isTourOpen && !isCloseConfirmOpen) return null;

  function handleConfirmClose() {
    disableTourGuide();
    confirmClose();
  }

  function handleCancelClose() {
    closeCloseConfirm();
    startTour(tourCurrentIndex);
  }

  function handlePillClose() {
    closeTour();
    openCloseConfirm();
  }

  return (
    <>
      {!tourGuideEnabled && (isUserGuideOpen || isTourOpen) && (
        <div className="fixed bottom-4 left-4 z-1060 flex items-center gap-2 rounded-full bg-surface shadow-lg border border-gray-700 pl-4 pr-2 py-2">
          <p className="text-sm font-medium text-text-900">{t('user_guide')}</p>
          <RiCloseLine className="cursor-pointer text-text-600" size={16} onClick={handlePillClose} />
        </div>
      )}
      <Modal
        title={
          <AppModal.Header>
            <AppModal.Title>{t('close_user_guide')}</AppModal.Title>
          </AppModal.Header>
        }
        centered
        open={isCloseConfirmOpen}
        footer={
          <AppModal.Footer>
            <AppModal.Button onClick={handleCancelClose} className="flex-1 capitalize!">
              {capitalize(t('cancel'))}
            </AppModal.Button>
            <AppModal.Button color="danger" onClick={handleConfirmClose} className="flex-1 capitalize!">
              {capitalize(t('close'))}
            </AppModal.Button>
          </AppModal.Footer>
        }
        classNames={{ content: 'max-w-[420px]' }}
        onCancel={handleCancelClose}
      >
        <AppModal.Body>
          <div className="mb-4">{t('you_can_reopen_it_anytime_from_the_profile_menu')}</div>
        </AppModal.Body>
      </Modal>
    </>
  );
}
